export const PAGE_NAME = 'coach-campaigns'
export const CAMPAIGNS_PATH = '/pga-coach/campaigns'
// ?step=audience|message|review opens the wizard at that step.
export const STEP_PARAM = 'step'

export const MESSAGE_MAX_LENGTH = 4000
export const NAME_MAX_LENGTH = 120
export const MAX_OFFERINGS = 5
export const MAX_MEDIA = 10
export const MAX_SCHEDULE_DAYS = 30
export const LOCAL_INPUT_FORMAT = "yyyy-MM-dd'T'HH:mm"

export const STATUS_LABELS = {
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  SENT: 'Sent',
  CANCELED: 'Canceled',
}

export const AGE_GROUP_OPTIONS = [
  { value: 'ALL', label: 'All ages' },
  { value: 'ADULT', label: 'Adults' },
  { value: 'JUNIOR', label: 'Juniors' },
]

export const SKILL_LEVEL_OPTIONS = [
  { value: 'NEW', label: 'New to golf' },
  { value: 'FAMILIAR', label: 'Familiar' },
  { value: 'INTERMEDIATE', label: 'Intermediate' },
  { value: 'ADVANCED', label: 'Advanced' },
]

// Maps to bookedWithinDays / notBookedWithinDays on the audience filters.
export const RECENCY_OPTIONS = [
  { value: 'any', label: 'Any time' },
  { value: 'booked-30', label: 'Had a lesson in the last 30 days' },
  { value: 'booked-90', label: 'Had a lesson in the last 90 days' },
  { value: 'lapsed-30', label: "Haven't had or booked a lesson in 30 days" },
  { value: 'lapsed-60', label: "Haven't had or booked a lesson in 60 days" },
  { value: 'lapsed-90', label: "Haven't had or booked a lesson in 90 days" },
  { value: 'lapsed-180', label: "Haven't had or booked a lesson in 6 months" },
]

export const EMPTY_FILTERS = {
  ageGroup: 'ALL',
  minAge: null,
  maxAge: null,
  skillLevels: [],
  lessonTypeIds: [],
  groupEventIds: [],
  programIds: [],
  facilityIds: [],
  bookedWithinDays: null,
  notBookedWithinDays: null,
  studentIds: [],
  excludedStudentIds: [],
}

export const EMPTY_CAMPAIGN = {
  id: null,
  name: '',
  body: '',
  audienceFilters: EMPTY_FILTERS,
  media: [],
  offerings: [],
}

export const SECTIONS = [
  {
    id: 'campaign-section-audience',
    label: 'Audience',
    pageTitle: 'Who is this campaign for?',
  },
  {
    id: 'campaign-section-message',
    label: 'Message',
    pageTitle: 'What do you want to say?',
  },
  {
    id: 'campaign-section-review',
    label: 'Review',
    pageTitle: 'Review and send',
  },
]
